import { ModalOverlay } from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';

import { noop } from '@blockpulse3/data/shared';
import { ResponsiveModal, ResponsiveModalProps } from '@blockpulse3/ui/commons';

import { VerificationStepCompany, VerificationStepUser } from './VerificationSteps';

type Props = {
  onClose: () => void;
  verificationStep: number;
  setVerificationStep: Dispatch<SetStateAction<number>>;
  refetchData: () => void;
  isUserWorkspace: boolean;
} & Omit<ResponsiveModalProps, 'children'>;

/**
 * IdentityVerificationModal.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function IdentityVerificationModal({
  verificationStep,
  setVerificationStep = noop,
  refetchData,
  isUserWorkspace,
  ...props
}: Props): JSX.Element {
  const handleCompanyStepSubmit = (): void => {
    setVerificationStep(1);
  };

  const handleOnClose = (): void => {
    if (verificationStep === 1) refetchData();
    setVerificationStep(0);
    props.onClose();
  };

  return (
    <ResponsiveModal {...props}>
      <ModalOverlay />
      {verificationStep === 0 ? (
        <VerificationStepCompany onSubmit={handleCompanyStepSubmit} />
      ) : (
        <VerificationStepUser isUserWorkspace={isUserWorkspace} onClose={handleOnClose} />
      )}
    </ResponsiveModal>
  );
}

export type IdentityVerificationModalProps = Props;
